import { render, staticRenderFns } from "./MarketplacePricingCard.vue?vue&type=template&id=7e590529&"
import script from "./MarketplacePricingCard.vue?vue&type=script&lang=js&"
export * from "./MarketplacePricingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports